var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { ContentWrapper } from 'ui-kit/content-wrapper';
import { PageLoader } from 'ui-kit/loader';
import styles from './open-pages-layout.module.scss';
export var OpenPagesLayout = function () {
    return (_jsx(ContentWrapper, __assign({ className: styles.root, classNameInner: styles.content, component: "main" }, { children: _jsx(Suspense, __assign({ fallback: _jsx(PageLoader, {}) }, { children: _jsx(Outlet, {}) })) })));
};
